import { PayloadAction } from "@reduxjs/toolkit";
import { T_LocalLiBaseData } from "./Li_BaseData_Types";

export const LI_ReduxInitialState = {
  isFetching: false,
  error: undefined,
  success: undefined,
  lastRanApiDetails: undefined,
};
export const LI_HandlingReducerAction = (
  state: T_LocalLiBaseData,
  action: PayloadAction<any, "fetching" | "error" | "success">
) => {
  switch (action.type) {
    case "fetching":
      return { ...state, isFetching: true };
    case "error":
      return {
        ...state,
        error: action.payload as Error,
        success: false,
        isFetching: false,
      };
    case "success":
      return {
        ...state,
        success: true,
        isFetching: false,
        error: undefined,
      };
    default:
      return state;
  }
};
